<div class="kd-hero">

  <h1>
    <span class="highlight">Key Dates</span> for 11plus Admissions
    <span class="highlight">2025-26</span>
  </h1>

  <h2>
    11+ Registration Deadlines | 11+ Exam Dates | 11+ Results Dates
  </h2>


</div>

<div class="dates-container">

<div class="dates-content">
<h2>Reading</h2>
  <p>Reading School, Kendrick School and Reading Girls’ School (partially-selective).</p>

  <ul>
    <li>Tuesday 1st April 2025: Reading School 11+ registration opens</li>
    <li>Thursday 1st May 2025: Kendrick School 11+ registration opens</li>
    <li>Friday 13th June 2025: Reading School 11+ registration closes</li>
    <li>Tuesday 1st July 2025: Kendrick School 11+ registration closes</li>
    <li>August 2025: Reading School sporting aptitude test</li>
    <li>Friday 5th September 2025: Reading School 11+ exam</li>
    <li>Friday 19th September 2025: Kendrick School 11+ exam</li>
    <li>September 2025: registration closes for the Reading Girls' School Selective Stream Test</li>
    <li>October 2025: Reading Girls’ School Selective Stream Test</li>
    <li>Mid-October 2025: parents receive exam results</li>
    <li>Friday 31st October 2025: secondary school common application deadline</li>
    <li>Monday 2nd March 2026: national school offers day</li>
  </ul>

</div>

<div class="dates-content">
<h2>Slough</h2>
  <p>Langley Grammar School, Herschel Grammar School, St Bernard’s Catholic Grammar School and Upton Court Grammar School. These schools are all members of the Slough Consortium of Grammar Schools. They have the same 11 plus exam and key dates.</p>

  <ul>
    <li>Tuesday 29th April 2025: Slough Consortium 11+ information evening</li>
    <li>Thursday 1st May 2025: Slough Consortium 11+ registration opens</li>
    <li>Thursday 5th June 2025: Slough Consortium 11+ registration closes</li>
    <li>Mid-October 2025: parents receive 11+ results</li>
    <li>Friday 31st October 2025: secondary school common application deadline</li>
    <li>Monday 2nd March 2026: national school offers day</li>

  
  </ul>


  
    

    

    

    

    

    

    

</div>

<div class="dates-content">
<h2>Buckinghamshire</h2>
  <p>There are 13 grammar schools in Buckinghamshire: Aylesbury Grammar School, Aylesbury High School, Beaconsfield High School, Burnham Grammar School, Chesham Grammar School, Dr Challoner’s Grammar School, Dr Challoner’s High School, John Hampden Grammar School, Royal Grammar School, Royal Latin School, Sir Henry Floyd Grammar School, Sir William Borlase’s Grammar School, and Wycombe High School. <br>

All of these schools are part of the The Buckinghamshire Grammar Schools (TBGS) Consortium. They share the same secondary transfer test (11+) and key dates.</p>

  <ul>
    <li>Friday 2nd May 2025: registration opens for the Buckinghamshire Secondary Transfer Test</li>
    <li>Friday 13th June 2025: registration closes for the Buckinghamshire Secondary Transfer Test</li>
    <li>Tuesday 9th September 2025: Buckinghamshire Practice Test</li>
    <li>Thursday 11th September 2025: Buckinghamshire Secondary Transfer Test</li>
    <li>Friday 10th October 2025: parents receive results from the Buckinghamshire Secondary Transfer Test</li>
    <li>Friday 31st October 2025: secondary school common application deadline</li>
    <li>Monday 2nd March 2026: national school offers day</li>

  
  </ul>

</div>

<div class="dates-content">
<h2>Cumbria</h2>
  <p>There is one grammar school in Cumbria – Queen Elizabeth’s Grammar School, Penrith.</p>

  <ul>
    <li>Thursday 1st May 2025: QEGS Penrith 11+ registration opens</li>
    <li>Thursday 10th July 2025: QEGS Penrith 11+ registration closes</li>
    <li>Thursday 18th September 2025: QEGS Penrith 11+ exam</li>
    <li>Mid-October 2025: parents receive exam results</li>
    <li>Friday 31st October 2025: secondary school common application deadline</li>
    <li>Monday 2nd March 2026: national school offers day</li>

  
  </ul>

</div>

<div class="dates-content">
<h2>Essex</h2>
  <p>There are 11 grammar schools in Essex: King Edward VI Grammar School, Chelmsford County High School for Girls, Colchester County High School for Girls, Colchester Royal Grammar School, Southend High School for Boys, Southend High School for Girls, Westcliff High School for Boys, Westcliff High School for Girls, St Bernard’s High School, St Thomas More High School, and Shoeburyness High School. <br>

All of these schools except Chelmsford County High School for Girls are members of the Consortium of Selective Schools in Essex (CSSE). Chelmsford County High School for Girls (CCHS) is not a member of the CSSE – it has its own testing process.</p>

  <ul>
    <li>Wednesday 2nd April 2025: CCHS entrance test registration opens</li>
    <li>Tuesday 13th 2025: CSSE 11+ registration opens</li>
    <li>Wednesday 4th June 2025: CCHS entrance test registration closes</li>
    <li>Friday 27th 2025: CSSE 11+ registration closes, and deadline for requests for special adjustments</li>
    <li>July 2025: parents receive test centre information for CSSE 11+ by 16th July</li>
    <li>Wednesday 3rd September 2025: CCHS entrance test</li>
    <li>Saturday 20th September 2025: CSSE 11+ exam day</li>
    <li>Monday 13th October 2025: parents receive CSSE 11+ results</li>
    <li>Mid-October 2025: parents receive CCHS results</li>
    <li>Friday 31st October 2025: secondary school common application deadline</li>
    <li>Monday 2nd March 2026: national school offers day</li>
  
  </ul>

</div>

<div class="dates-content">
<h2>Kent</h2>
  <p>There are 32 grammar schools in Kent. These schools are Barton Court Grammar School, Borden Grammar School, Chatham and Clarendon Grammar School, Cranbrook School, Dane Court Grammar School, Dartford Grammar School, Dartford Grammar School for Girls, Dover Grammar School for Boys, Dover Grammar School for Girls, Gravesend Grammar School, Highsted Grammar School, Highworth Grammar School, Invicta Grammar School, Maidstone Grammar School, Maidstone Grammar School for Girls, Mayfield Grammar School, Oakwood Park Grammar School, Queen Elizabeth’s Grammar School, Simon Langton Girls’ Grammar School, Sir Roger Manwood’s School, The Folkestone School for Girls, The Harvey Grammar School, The Judd School, The Langton Grammar School for Boys, The Norton Knatchbull School, The Skinners’ School, Tonbridge Grammar School, Tunbridge Wells Girls’ Grammar School, Tunbridge Wells Grammar School for Boys, Weald of Kent Grammar School, Wilmington Grammar School for Boys, and Wilmington Grammar School for Girls. <br>

Children applying to any grammar school in the Kent local authority area take an 11 plus exam known as the Kent Test.</p>

  <ul>
    <li>Monday 2nd June 2025: Kent Test registration opens</li>
    <li>Tuesday 1st July 2025: Kent Test registration closes</li>
    <li>Early September 2025: Kent County Council opens secondary school applications</li>
    <li>Thursday 11th September 2025: Kent Test date for children in Kent primary schools</li>
    <li>Saturday 13th – Sunday 14th 2025 Kent Test date for children not in Kent primary schools</li>

    <li>Thursday 16th October 2025: Kent Test results sent to parents</li>

    <li>Friday 31st October 2025: secondary school common application deadline</li>

    <li>Monday 13th October 2025: parents receive CSSE 11+ results</li>
    <li>Monday 2nd March 2026: national school offers day</li>
    <li>Friday 31st October 2025: secondary school common application deadline</li>
    <li>Monday 2nd March 2026: national school offers day</li>
  
  </ul>


      

    

    

    

    

    

    

    

</div>

<div class="dates-content">
<h2>Redbridge</h2>
  <p>There are two grammar schools in Redbridge: Ilford County High School and Woodford County High School. They have the same exam and key dates.</p>

  <ul>
    <li>Tuesday 1st May 2025: Redbridge 11+ registration opens</li>
    <li>Sunday 15th June 2025: Redbridge 11+ registration closes</li>
    <li>Friday 19th September 2025: Redbridge 11+ selection test</li>
    <li>Mid-October 2025: parents receive exam results</li>
    <li>Friday 31st October 2025: secondary school common application deadline</li>

    <li>Monday 2nd March 2026: national school offers day</li>
  
  </ul>


      
    

    

    

    

    

    

</div>

<div class="dates-content">
<h2>Bexley</h2>
  <p>There are two grammar schools in Redbridge: Ilford County High School and Woodford County High School. They have the same exam and key dates.</p>

  <ul>
    <li>Tuesday 1st May 2025: Bexley Selection Test registration opens</li>
    <li>Saturday 31st May 2025: Bexley Selection Test registration closes at midnight</li>
    <li>Tuesday 9th September 2025: Bexley Selection Test (pupils who attend a Bexley primary school)</li>
    <li>Monday 8th – Thursday 11th September 2025: Bexley Selection Test (pupils who do not attend a Bexley primary school)</li>
    <li>Mid-October 2025: parents receive results from the Bexley Selection Test</li>
    <li>Friday 31st October 2025: secondary school common application deadline</li>
    <li>Monday 2nd March 2026: national school offers day</li>
  
  </ul>

</div>



</div>